import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useScrollTo } from '../hooks/useScrollTo';
import HeroSection from '../components/sections/HeroSection';
import MissionVisionSection from '../components/sections/MissionVisionSection';
import ApplicationsSection from '../components/sections/ApplicationsSection';
import PricingSection from '../components/sections/PricingSection';
import CTASection from '../components/sections/CTASection';

export default function Landing() {
  const location = useLocation();
  const scrollTo = useScrollTo();

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace('#', '');
      setTimeout(() => {
        scrollTo(hash);
      }, 100);
    }
  }, [location.hash, scrollTo]);

  return (
    <>
      <HeroSection />
      <MissionVisionSection />
      <ApplicationsSection />
      <PricingSection />
      <CTASection />
    </>
  );
}